// /organization CRUD and presigned uploads.

import { defineRoutes, demoError } from '../core';
import type { OrganizationRequest, UpdateOrganizationRequest } from '../../types/organization.type';
import {
  DEMO_ORG_IDS,
  createOrganization,
  deleteOrganization,
  demoOrganization,
  listOrganizations,
  updateOrganization,
} from '../data/organizations';
import { createPresignedUpload } from '../data/uploads';
import { body, str } from './errors';

export const organizationRoutes = defineRoutes([
  ['get', '/organization', (ctx) => ({ result: listOrganizations(ctx.query) })],
  ['post', '/organization', (ctx) => ({ result: createOrganization(body<OrganizationRequest>(ctx.body)) })],
  [
    'get',
    '/organization/:id',
    (ctx) => {
      const org = demoOrganization(ctx.params.id);
      return org ? { result: org } : demoError(404, 'Organization not found');
    },
  ],
  [
    'put',
    '/organization/:id',
    (ctx) => {
      const org = updateOrganization(ctx.params.id, body<UpdateOrganizationRequest>(ctx.body));
      return org ? { result: org } : demoError(404, 'Organization not found');
    },
  ],
  [
    'delete',
    '/organization/:id',
    (ctx) => {
      if (DEMO_ORG_IDS.includes(ctx.params.id)) return demoError(403, 'Demo organizations cannot be deleted');
      return deleteOrganization(ctx.params.id) ? { result: { success: true } } : demoError(404, 'Organization not found');
    },
  ],
  [
    'post',
    '/upload',
    (ctx) => ({ result: createPresignedUpload(str(ctx.query.file_type) ?? 'upload', str(ctx.query.file_extension) ?? 'png') }),
  ],
]);
